/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { Button, Col, DatePicker, Form, Row, Select, Modal } from "antd";
import "../../styles/filters-form.less";
import "./ClosedDocuments.less";

import { jwtDecode } from "jwt-decode";
import {
  displayFormat,
  toHttpFormatEndOfDay,
  toHttpFormatStartOfDay,
} from "../../lib/utils/formatDate";
import { invoicesBulkCreate } from "../../store/slices/invoices";
import AuthService from "../../services/AuthService";
import { postChargesBulkCreate } from "../../store/slices/charges";
import { postBillPeriodCreate } from "../../store/slices/bills";
import { checkIsLoading } from "../../lib/utils/checkLoadingStatus";
import { hasAccess } from "../RolesModule/hasAccess";
import { MENU_BILLING_BILLINGPROCEDURES_WRITE } from "../../lib/const/permissions";
import useDebounce from "../../lib/hooks/useDebounce";

const dateFormat = displayFormat;

const ClosedDocuments = () => {
  const userName = jwtDecode(AuthService.getCurrentUser());
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [activeModal, setActiveModal] = useState(false);
  const [selectTask, setSelectTask] = useState("createCharges");
  const startOfMonth = moment().startOf("month");
  const endOfPrevMonth = moment().subtract(1, "months").endOf("month");
  const getTwoMonthBefore = (date) => moment(date).subtract(2, "month").add(1, "millisecond");
  const { postBillPeriodCreateLoading } = useSelector((state) => state.bills);
  const { postChargesMassCreateLoading, postChargesBulkCreateLoading } = useSelector(
    (state) => state.charges
  );

  const isCreateCharge = selectTask === "createCharges";
  const isCreateInvoice = selectTask === "createInvoice";
  const isCreateBill = selectTask === "createBills";

  const layoutCol1 = {
    wrapperCol: { span: 12 },
    labelCol: { span: 7 },
  };

  const style = {
    modalHeader: {
      fontSize: "14px",
      color: "#5D6C7A",
    },
    modalSubHeader: {
      fontSize: "16px",
      color: "#112244",
    },
    modalInitiator: {
      fontSize: "14px",
      color: "#5D6C7A",
      label: {
        color: "#000000",
        marginLeft: "5px",
      },
    },
    modalFooter: {
      fontSize: "16px",
      color: "#112244",
    },
  };

  const taskList = [
    { id: "createCharges", name: "Создание начислений" },
    { id: "createInvoice", name: "Создание инвойсов" },
    { id: "createBills", name: "Создание счетов на постоплату" },
  ];

  const onChangeTask = (value) => {
    setSelectTask(value);

    form.setFieldsValue({
      periodFrom: getTwoMonthBefore(endOfPrevMonth),
      periodTo: endOfPrevMonth,
      invoiceDate: moment().subtract(1, "month").endOf("month"),
    });

  };

  const returnModalTaskName = () => {
    let name;
    if (isCreateCharge) {
      name = "Создание начислений";
    }
    if (isCreateInvoice) {
      name = "Создание инвойсов";
    }
    if (isCreateBill) {
      name = "Создание счетов на постоплату";
    }
    return name;
  };

  const onChangePeriodToCreateCharge = (value) => {
    if (isCreateCharge) {
      const periodFrom = form.getFieldValue("periodFrom");
      if (moment(periodFrom).isAfter(value)) {
        Modal.warning({
          title: "Начало расчетного периода позднее конца расчетного периода!",
          content: "Начало расчетного периода будет очищено",
          onOk: () => form.setFieldsValue({ periodFrom: null }),
          onCancel: () => form.setFieldsValue({ periodFrom: null }),
        });
      } else {
        const onConfirm = () => {
          form.setFieldsValue({ periodFrom: getTwoMonthBefore(value) });
        };
        Modal.confirm({
          content: "Начало расчетного периода будет изменено. Вы хотите сохранить текущее значение?",
          okText: "Далее",
          okButtonProps: { style: { width: "108px" } },
          onOk: onConfirm,
          cancelText: "Сохранить",
          cancelButtonProps: { style: { width: "108px" } },
        });
      }
    }
  };

  const disablePeriodFromCreateCharge = (date) => {
    const periodTo = form.getFieldValue("periodTo");
    return date.isAfter(periodTo);
  };

  // Сделано через задержку, чтобы избежать повторного срабыватывания при двойном нажатии
  const hadleCreate = useDebounce(({ periodTo, periodFrom, invoiceDate }) => {
    if (isCreateCharge) {
      dispatch(
        postChargesBulkCreate({
          periodFrom: periodFrom ? toHttpFormatStartOfDay(periodFrom) : undefined,
          periodTo: toHttpFormatEndOfDay(periodTo),
        })
      );
    }
    if (isCreateBill) {
      dispatch(postBillPeriodCreate(toHttpFormatEndOfDay(periodTo)));
    }
    if (isCreateInvoice) {
      const bodyRequest = {
        periodFrom: null,
        periodTo: toHttpFormatEndOfDay(periodTo),
        excludeInvoicePeriod: [1000],
      };
      if (invoiceDate) {
        bodyRequest.effectiveDate = toHttpFormatEndOfDay(invoiceDate);
      }
      dispatch(invoicesBulkCreate(bodyRequest));
    }
  }, 300);

  const onFinish = (values) => {
    setActiveModal(false);
    hadleCreate(values);
  };

  return (
    <>
      <h3 className="invoice-period-header">Параметры запуска</h3>
      <Form
        name="dynamic_form_nest_item"
        onFinish={onFinish}
        initialValues={{
          periodFrom: getTwoMonthBefore(endOfPrevMonth),
          periodTo: endOfPrevMonth,
        }}
        form={form}
        autoComplete="off"
      >
        <Row align="top" style={{ paddingBottom: "10%" }}>
          <Col span={12}>
            {isCreateCharge && (
              <Form.Item
                label="Начало расчетного периода"
                name="periodFrom"
                labelAlign="left"
                {...layoutCol1}
              >
                <DatePicker
                  allowClear
                  style={{ minWidth: "140px" }}
                  placeholder="Выберите месяц"
                  format={dateFormat}
                  disabledDate={disablePeriodFromCreateCharge}
                />
              </Form.Item>
            )}

            <Form.Item
              label="Конец расчетного периода"
              name="periodTo"
              labelAlign="left"
              {...layoutCol1}
              rules={[{ required: true }]}
            >
              <DatePicker
                allowClear={false}
                style={{ minWidth: "140px" }}
                placeholder="Выберите месяц"
                format={dateFormat}
                onChange={onChangePeriodToCreateCharge}
              />
            </Form.Item>

            {isCreateInvoice && (
              <Form.Item
                label="Дата счета-фактуры"
                name="invoiceDate"
                labelAlign="left"
                {...layoutCol1}
                initialValue={moment().subtract(1, "month").endOf("month")}
              >
                <DatePicker allowClear style={{ minWidth: "140px" }} format={dateFormat} />
              </Form.Item>
            )}
          </Col>
          <Col span={12}>
            <label style={{ marginRight: "15px" }}>Задание</label>
            <Select
              defaultValue="createCharges"
              value={selectTask}
              onChange={onChangeTask}
              style={{ width: "240px" }}
            >
              {taskList &&
                taskList.map((item) => (
                  <Select.Option key={item.id} value={item.id}>
                    {item.name}
                  </Select.Option>
                ))}
            </Select>
          </Col>
        </Row>
        {hasAccess(MENU_BILLING_BILLINGPROCEDURES_WRITE) && (
          <Row align="center" style={{ borderTop: "1px solid #CCDDEE", paddingTop: "15px" }}>
            {/* <Button onClick={onReset} style={{ marginRight: "15px" }}>
              Отмена
            </Button> */}
            <Button
              type="primary"
              loading={checkIsLoading(
                postBillPeriodCreateLoading,
                postChargesMassCreateLoading,
                postChargesBulkCreateLoading
              )}
              onClick={() => setActiveModal(true)}
            >
              Создать задание
            </Button>
          </Row>
        )}
      </Form>

      <Modal
        visible={activeModal}
        onCancel={() => setActiveModal(false)}
        onOk={form.submit}
        cancelText="Отмена"
        okText="Далее"
        bodyStyle={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          height: "200px",
          fontSize: "16px",
        }}
      >
        <p style={style.modalHeader}>Будет сформировано задание на выполнение операции</p>
        <p style={style.modalSubHeader}>{returnModalTaskName()}</p>
        <p style={style.modalInitiator}>
          Инициатор:
          <span style={style.modalInitiator.label}>{userName.display_name}</span>
        </p>
        <p style={style.modalFooter}>Для продолжения нажмите «Далее»</p>
      </Modal>
    </>
  );
};

export default ClosedDocuments;
